import TreatmentPage from "./TreatmentPage";

export default function ChemicalPeeling() {
  return (
    <TreatmentPage
      title="Chemical Peeling"
      heroImage="/Treatment/Chemical-Peeling-drtruptis-clinic.jpg"

      intro="Chemical Peeling is a non-surgical dermatological procedure that uses safe chemical solutions such as glycolic acid, salicylic acid, or TCA to exfoliate the damaged outer layers of the skin. This process removes dead skin cells and stimulates the growth of new, healthy skin, resulting in a smoother, brighter, and more evenly toned complexion."

      description="Chemical peels are widely used to treat acne, acne scars, pigmentation, uneven skin tone, sun damage, and early signs of aging. The treatment helps rejuvenate the skin and improve its overall texture and appearance."

      howItWorks="During the procedure, a specially formulated chemical solution is applied to the skin. Superficial peels remove dead skin cells from the outermost layer. Medium-depth peels penetrate deeper to treat acne scars and wrinkles. Deep peels work on deeper skin layers to reduce severe sun damage and improve skin texture."

      benefits={[
        "Reduces acne and acne scars.",
        "Improves skin texture and smoothness.",
        "Reduces wrinkles and fine lines.",
        "Lightens dark spots and pigmentation.",
        "Improves uneven skin tone.",
        "Helps repair sun-damaged skin.",
        "Promotes brighter and healthier skin."
      ]}

      beforeAfterImages={[
        "/Treatment/before-chemical-peeling-drtruptis-clinic.jpeg",
        "/Treatment/after-chemical-peeling-drtruptis-clinic.jpeg",
      ]}

      faqs={[
        { q: "Is chemical peeling safe?", a: "Yes, when performed by a qualified dermatologist it is a safe and effective procedure." },
        { q: "How many sessions are required?", a: "Usually 3–6 sessions are recommended depending on the skin condition." },
        { q: "Is there any downtime?", a: "Mild redness or peeling may occur for a few days depending on the depth of the peel." },
        { q: "When will I see results?", a: "Most patients notice brighter and smoother skin within a few days after the treatment." }
      ]}
    />
  );
}